@if (formData.formGroup) {
  <div class="input-wrapper"
       [formGroup]="formData.formGroup"
       [class.no-icon]="!formData.iconLeft">
    @if (isLoading) {
      <p-skeleton height="41px"
                  class="mb-2" />

      <label [for]="formData.id"
             class="label skeletonLabel">
        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>
    } @else {
      <label [for]="formData.id"
             class="label">
        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>

      <div class="tag-input-shell"
           [class.is-readonly]="formData.readonly"
           (click)="focusInput()">
        @for (tag of tags; track i; let i = $index) {
          <span
            class="tag-chip"
            (click)="editTag(i); $event.stopPropagation()">

            <span class="tag-chip__text">
              {{ tag }}
            </span>

            @if (!formData.readonly) {
              <button
                type="button"
                class="tag-chip__remove"
                (click)="removeTag(i); $event.stopPropagation()">
                ×
              </button>
            }
          </span>
        }

        @if (!formData.readonly) {
          <input
            #tagInput
            class="tag-input-shell__input"
            list="tag-input-shell__datalist"
            [id]="formData.id"
            type="text"
            [placeholder]="tags.length ? '' : (formData.placeholder || '')"
            [value]="inputValue"
            (input)="inputValue = ($any($event.target).value); onInput($event)"
            (keydown)="onKeyDown($event)"
            (blur)="onBlur()"
          />

          <datalist id="tag-input-shell__datalist">
            @for (option of emailList; track i; let i = $index) {
              <option value="{{ option }}">
            }
          </datalist>
        }
      </div>
    }
  </div>
}

@if (formData.infoText) {
  <p class="message info">
    {{ formData.infoText }}
  </p>
}
